import {
  Button,
  Card,
  CardContent,
  Grid,
  Icon,
  Typography
} from "@material-ui/core";
import React from "react";

const QuoteCard = props => {
  return (
    <Card
      style={{
        padding: "10px 0px",
        margin: "10px 0px"
      }}
    >
      <CardContent style={{ paddingLeft: "10px", paddingBottom: "0px" }}>
        <div
          style={{
            display: "flex"
          }}
        >
          <Icon
            style={{
              width: "40px",
              height: "40px",
              fontSize: "40px"
            }}
          >
            assignment
          </Icon>
          <div
            style={{
              marginLeft: "15px",
              width: "70%"
            }}
          >
            <Typography gutterBottom style={{ wordWrap: "break-word" }}>
              {props.title}
            </Typography>
            <Typography
              gutterBottom
              variant="caption"
              style={{ wordWrap: "break-word" }}
            >
              {props.desc}
            </Typography>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            marginTop: "15px"
          }}
        >
          <Grid container justify="space-between">
            <Grid item>
              <Button
                size="small"
                mini
                color="secondary"
                onClick={props.handleView}
              >
                View
              </Button>
            </Grid>
            <Grid item>
              <Button
                size="small"
                mini
                style={{
                  color: "red"
                }}
                onClick={props.handleRemove}
              >
                Remove
              </Button>
            </Grid>
          </Grid>
        </div>
      </CardContent>
    </Card>
  );
};

export default QuoteCard;



// WEBPACK FOOTER //
// ./src/views/Documents/QuoteCard.jsx